var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"openid-modify"},[_c('OpenidForm',{attrs:{"operate":"modify"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }